// 常量路由
export const constantRoutes = [
  {
    path: "/",
    redirect: "/dashboard",
    meta: {
      hidden: true,
    },
  },
  {
    path: "/login",
    meta: {
      hidden: true,
    },
    component: () => import("@/views/login/index"),
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    meta: {
      icon: "el-icon-s-home",
      name: "首页",
      affix: true,
    },
    component: () => import("@/views/dashboard/index.vue"),
  },
];

// 任意路由
export const anyRoutes = [
  //
];

// 动态路由
export const asyncRoutes = () => [
  {
    path: "/member",
    name: "MemberManage",
    redirect: "/member/list",
    component: () => import("@/views/member-manage/index.vue"),
    meta: {
      name: "用户管理",
      icon: "el-icon-user-solid",
    },
    children: [
      {
        path: "/member/list",
        name: "MemberList",
        component: () => import("@/views/member-manage/member-list/index.vue"),
        meta: {
          name: "用户列表",
          keepAlive: true,
        },
      },
      {
        path: "/member/roster/allow-list",
        name: "RosterAllowList",
        component: () => import("@/views/member-manage/roster-list/allow-list.vue"),
        meta: {
          name: "白名单列表",
          keepAlive: true,
        },
      },
      {
        path: "/member/roster/deny-list",
        name: "RosterDenyList",
        component: () => import("@/views/member-manage/roster-list/deny-list.vue"),
        meta: {
          name: "黑名单列表",
          keepAlive: true,
        },
      },
    ],
  },
  {
    path: "/product",
    name: "ProductManage",
    redirect: "/product/list",
    meta: {
      icon: "el-icon-s-goods",
      name: "产品管理",
    },
    component: () => import("@/views/product-manage/index.vue"),
    children: [
      {
        path: "/product/list",
        name: "ProductList",
        component: () => import("@/views/product-manage/product-list/index.vue"),
        meta: {
          name: "产品列表",
          keepAlive: true,
        },
      },
      {
        path: "/product/add",
        name: "ProductAdd",
        component: () => import("@/views/product-manage/product-list/add-edit.vue"),
        meta: {
          name: "创建产品",
          hidden: true,
          keepAlive: false,
          activeMenu: "/product/list",
        },
      },
      {
        path: "/product/edit/:id?",
        name: "ProductEdit",
        component: () => import("@/views/product-manage/product-list/add-edit.vue"),
        meta: {
          name: "编辑产品",
          hidden: true,
          keepAlive: false,
          activeMenu: "/product/list",
        },
      },
      // {
      //   path: "/product/cate/list",
      //   name: "ProductCateList",
      //   component: () => import("@/views/product-manage/product-cate/index.vue"),
      //   meta: {
      //     name: "产品分类",
      //     keepAlive: true,
      //   },
      // },
      {
        path: "/product/bi/day/list",
        name: "ProductBiDayList",
        component: () => import("@/views/product-manage/product-bi/day-list.vue"),
        meta: { name: "产品日数据统计" },
      },
      {
        path: "/product/bi/month/list",
        name: "ProductBiMonthList",
        component: () => import("@/views/product-manage/product-bi/month-list.vue"),
        meta: { name: "产品月数据统计" },
      },
      {
        path: "/product/bi/overview/list",
        name: "ProductBiOverviewList",
        component: () => import("@/views/product-manage/product-bi/overview-list.vue"),
        meta: { name: "产品数据总览" },
      },
    ],
  },
  {
    path: "/channel",
    name: "ChannelManage",
    redirect: "/channel/list",
    meta: {
      icon: "el-icon-s-goods",
      name: "渠道管理",
    },
    component: () => import("@/views/channel-manage/index.vue"),
    children: [
      {
        path: "/channel/list",
        name: "ChannelList",
        component: () => import("@/views/channel-manage/channel-list/list.vue"),
        meta: {
          name: "渠道列表",
          keepAlive: true,
        },
      },
      {
        path: "/channel/add",
        name: "ChannelAdd",
        component: () => import("@/views/channel-manage/channel-list/add-edit.vue"),
        meta: {
          name: "创建渠道",
          hidden: true,
          keepAlive: false,
          activeMenu: "/channel/list",
        },
      },
      {
        path: "/channel/edit/:id?",
        name: "ChannelEdit",
        component: () => import("@/views/channel-manage/channel-list/add-edit.vue"),
        meta: {
          name: "编辑渠道",
          hidden: true,
          keepAlive: false,
          activeMenu: "/channel/list",
        },
      },
      {
        path: "/channel/bi/day/list",
        name: "ChannelBiDayList",
        component: () => import("@/views/channel-manage/channel-bi/day-list.vue"),
        meta: { name: "渠道日数据统计" },
      },
      {
        path: "/channel/bi/month/list",
        name: "ChannelBiMonthList",
        component: () => import("@/views/channel-manage/channel-bi/month-list.vue"),
        meta: { name: "渠道月数据统计" },
      },
      {
        path: "/channel/bi/overview/list",
        name: "ChannelBiOverviewList",
        component: () => import("@/views/channel-manage/channel-bi/overview-list.vue"),
        meta: { name: "渠道数据总览" },
      },
    ],
  },
  {
    path: "/oprt",
    name: "OprtManage",
    component: () => import("@/views/oprt-manage/index.vue"),
    meta: { name: "运营管理", icon: "el-icon-s-finance" },
    children: [
      {
        path: "/oprt/ad",
        name: "OprtAd",
        component: () => import("@/views/oprt-manage/ad/list.vue"),
        meta: { name: "广告设置" },
      },
      {
        path: "/oprt/doc",
        name: "OprtDoc",
        component: () => import("@/views/oprt-manage/doc/list.vue"),
        meta: { name: "协议合同" },
      },
    ],
  },
  {
    path: "/power-manage",
    name: "PowerManage",
    redirect: "/power-manage/user/list",
    component: () => import("@/views/power-manage/index.vue"),
    meta: { name: "权限管理", icon: "el-icon-s-check" },
    children: [
      {
        path: "/power-manage/user/list",
        name: "UserList",
        component: () => import("@/views/power-manage/user/list.vue"),
        meta: { name: "管理员" },
      },
      {
        path: "/power-manage/user/add",
        name: "UserAdd",
        component: () => import("@/views/power-manage/user/add-edit.vue"),
        meta: {
          name: "新增管理员",
          hidden: true,
          activeMenu: "/power-manage/user/list",
        },
      },
      {
        path: "/power-manage/user/edit/:id?",
        name: "UserEdit",
        component: () => import("@/views/power-manage/user/add-edit.vue"),
        meta: {
          name: "编辑管理员",
          hidden: true,
          activeMenu: "/power-manage/user/list",
        },
      },
      {
        path: "/power-manage/role/list",
        name: "RoleList",
        component: () => import("@/views/power-manage/role/list.vue"),
        meta: { name: "角色管理" },
      },
      {
        path: "/power-manage/role/add",
        name: "RoleAdd",
        component: () => import("@/views/power-manage/role/add-edit.vue"),
        meta: {
          name: "新增",
          hidden: true,
          activeMenu: "/power-manage/role/list",
        },
      },
      {
        path: "/power-manage/role/edit/:id?",
        name: "RoleEdit",
        component: () => import("@/views/power-manage/role/add-edit.vue"),
        meta: {
          name: "编辑",
          hidden: true,
          activeMenu: "/power-manage/role/list",
        },
      },
      {
        path: "/power-manage/menu/list",
        name: "MenuList",
        component: () => import("@/views/power-manage/menu/list.vue"),
        meta: { name: "菜单管理", keepAlive: true },
      },
      {
        path: "/power-manage/menu/add/:menuId?/:parentId?",
        name: "MenuAdd",
        component: () => import("@/views/power-manage/menu/add-edit.vue"),
        meta: {
          name: "新增",
          hidden: true,
          activeMenu: "/power-manage/menu/list",
        },
      },
      {
        path: "/power-manage/menu/edit/:menuId?/:parentId?",
        name: "MenuEdit",
        component: () => import("@/views/power-manage/menu/add-edit.vue"),
        meta: {
          name: "编辑",
          hidden: true,
          activeMenu: "/power-manage/menu/list",
        },
      },
      {
        path: "/power-manage/dept/list",
        name: "Dept",
        component: () => import("@/views/power-manage/dept/list.vue"),
        meta: { name: "部门管理" },
      },
    ],
  },
  {
    path: "/system-manage",
    name: "SystemManage",
    redirect: "/system-manage/dict/list",
    component: () => import("@/views/system-manage/index.vue"),
    meta: { name: "系统管理", icon: "el-icon-setting" },
    children: [
      {
        path: "/system-manage/dict/list",
        name: "DictList",
        component: () => import("@/views/system-manage/dict/list.vue"),
        meta: { name: "字典管理" },
      },
      {
        path: "/system-manage/dict/add-edit",
        name: "DictAddOrEdit",
        component: () => import("@/views/system-manage/dict/add-edit.vue"),
        meta: {
          hidden: true,
          name: "字典管理",
          activeMenu: "/system-manage/dict/list",
        },
      },
      {
        path: "/system-manage/dict/enum/list",
        name: "DictEnumList",
        component: () => import("@/views/system-manage/dict/enum/list.vue"),
        meta: {
          hidden: true,
          name: "字典值管理",
          activeMenu: "/system-manage/dict/list",
        },
      },
      {
        path: "/system-manage/dict/enum/add-edit",
        name: "DictEnumAddOrEdit",
        component: () => import("@/views/system-manage/dict/enum/add-edit.vue"),
        meta: {
          hidden: true,
          name: "字典值管理",
          activeMenu: "/system-manage/dict-manage/list",
        },
      },
      {
        path: "/system-manage/log/list",
        name: "SystemLogList",
        component: () => import("@/views/system-manage/log/list.vue"),
        meta: { name: "操作日志" },
      },
    ],
  },
];
